import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getUpcomingAppointments } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useAuth } from "../../../contexts/auth-context";

export function useUpcomingAppointments({
  selectedPatient,
}: {
  selectedPatient: string | null;
}) {
  const { toast } = useToast();

  const { mobile } = useAuth();

  const {
    data: appointments,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["upcoming-appointments", selectedPatient, mobile],
    queryFn: () => getUpcomingAppointments(selectedPatient, mobile),
    enabled: !!mobile && !!selectedPatient,
    retry: 0,
  });

  useEffect(() => {
    if (isError && selectedPatient) {
      toast({
        title: "Failed to fetch upcoming appointments",
        variant: "destructive",
      });
    }
  }, [isError, toast, selectedPatient]);

  return { appointments, isLoading, isFetched };
}
